import {Component, Input} from '@angular/core';
import {NgClass, NgFor} from '@angular/common';

@Component({
  selector: 'app-accommodation-list-ph',
  templateUrl: './accommodation-list-ph.component.html',
  styleUrls: ['./accommodation-list-ph.component.scss'],
  standalone: true,
  imports: [NgClass, NgFor]
})
export class AccommodationListPhComponent {
  @Input() public isProfile: boolean = false;


}
